import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const RolloutStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Rollout Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
